import { CDK_DRAG_PARENT, CdkDragHandle } from '@angular/cdk/drag-drop';
import {
    AfterViewInit,
    Component,
    EventEmitter,
    HostListener,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Optional,
    Output,
    ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DayTimeOptions } from 'src/app/classes/day-time-options';
import { Entity } from 'src/app/classes/entity.class';
import { Hiring } from 'src/app/classes/hiring';
import { Leave } from 'src/app/classes/leave';
import { PlanningHasEntity } from 'src/app/classes/planning-has-entity.class';
import { Planning } from 'src/app/classes/planning.class';
import { PlanningAsfaltteam } from 'src/app/classes/planningasfaltteam.class';
import { PlanningCutter } from 'src/app/classes/planningcutter.class';
import { PlanningDumper } from 'src/app/classes/planningdumper.class';
import { PlanningTruck } from 'src/app/classes/planningtruck.class';
import { Project } from 'src/app/classes/project.class';
import { DefaultStand, User } from 'src/app/classes/user.class';
import { CodaltComponent } from 'src/app/codalt.component';
import { EntityType, EntityTypeCode } from 'src/app/services/entities/entity-type.class';
import { PlanningService } from 'src/app/services/planning/planning.service';
import { ProjectService } from 'src/app/services/project.service';

interface PlanningForm {
    mainPlanning: PlanningHasEntity;
    planning?: Planning;
    entities: {
        fg: FormGroup;
        planning: PlanningHasEntity;
        highlight?: boolean;
    }[];
    hasSets?: boolean;
    asphaltTrucks?: number;
    cutterTrucks?: number;
    saving?: boolean;
}

@Component({
    selector: '[app-transport-planning-row]',
    templateUrl: './transport-planning-row.component.html',
    styleUrls: ['./transport-planning-row.component.scss'],
    standalone: false,
})
export class TransportPlanningRowComponent extends CodaltComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() readOnly: boolean;

    @Input() pln: PlanningHasEntity;

    @Input() main: PlanningForm;

    @Input() fg: FormGroup;
    @Input() highlight: boolean;
    @Input() i: number;
    @Input() readonly: boolean;
    @Input() drivers: User[];
    @Input() lowLoaders: Entity[];
    @Input() employees: User[];
    @Input() executors: User[];
    @Input() entitiesMap: Map<number, Entity>;
    @Input() planning: Planning[];
    @Input() currentDate = new Date();
    @Input() entityTypes: EntityType[];
    @Input() hiringMap = new Map<string, Hiring[]>();
    @Input() trucks: Entity[];
    @Output() addChooseEntity: EventEmitter<{
        planningForm: PlanningForm;
        type: EntityType;
        pheId?: number;
        disableFromCurrentPlanning: boolean;
    }> = new EventEmitter();
    @Output() deletePlanningEmitter: EventEmitter<PlanningHasEntity> = new EventEmitter();
    @Output() duplicatePlanningEmitter: EventEmitter<{
        planning: PlanningHasEntity;
        main: PlanningForm;
        formGroup: FormGroup;
        previous: boolean;
    }> = new EventEmitter();
    @Output() duplicateExactEmitter: EventEmitter<{
        planning: PlanningHasEntity;
        main: PlanningForm;
        formGroup: FormGroup;
    }> = new EventEmitter();

    @ViewChild('menuTrigger') menuTrigger;
    @ViewChild('spanTrigger') spanTrigger;

    @Input() blockedMap: Map<number, { icon: string; description: string }>;
    @Input() leaveDayUserMap: Map<number, Leave> = new Map<number, Leave>();

    searchAfasProjects$ = new Subject<string>();
    projects: Project[];

    @ViewChild(CdkDragHandle, { static: true }) handle: CdkDragHandle;

    // tslint:disable-next-line:max-line-length
    @Input() startTimesEntity: Map<
        PlanningCutter | PlanningHasEntity | PlanningAsfaltteam | PlanningDumper | PlanningTruck,
        DayTimeOptions[]
    > = new Map<
        PlanningCutter | PlanningHasEntity | PlanningAsfaltteam | PlanningDumper | PlanningTruck,
        DayTimeOptions[]
    >();
    // tslint:disable-next-line:max-line-length
    @Input() endTimesEntity: Map<
        PlanningCutter | PlanningHasEntity | PlanningAsfaltteam | PlanningDumper | PlanningTruck,
        DayTimeOptions[]
    > = new Map<
        PlanningCutter | PlanningHasEntity | PlanningAsfaltteam | PlanningDumper | PlanningTruck,
        DayTimeOptions[]
    >();

    EntityTypeCode = EntityTypeCode;
    DefaultStand = DefaultStand;

    @Input() hiringAutocompleteOptions: string[];

    private static activeMenuTrigger: MatMenuTrigger | null = null;

    @HostListener('mousedown', ['$event']) onMouseDown($event: MouseEvent) {
        if ($event.button === 2) {
            // Prevents the right-click from focusing the target (e.g. the transport-address
            // input), which would otherwise open its mat-autocomplete panel before our
            // contextmenu handler gets a chance to show the row's context menu.
            $event.preventDefault();
        }
    }

    @HostListener('contextmenu', ['$event']) onContxtMenu($event) {
        if (
            TransportPlanningRowComponent.activeMenuTrigger &&
            TransportPlanningRowComponent.activeMenuTrigger !== this.menuTrigger
        ) {
            TransportPlanningRowComponent.activeMenuTrigger.closeMenu();
        }
        this.spanTrigger.nativeElement.style.left = $event.clientX + 5 + 'px';
        this.spanTrigger.nativeElement.style.top = $event.clientY + 5 + 'px';
        TransportPlanningRowComponent.activeMenuTrigger = this.menuTrigger;
        if (this.menuTrigger.menuOpen) {
            this.menuTrigger.closeMenu();
            this.menuTrigger.openMenu();
        } else {
            this.menuTrigger.openMenu();
        }
        $event.preventDefault();
        $event.stopPropagation();
    }

    constructor(
        @Optional() @Inject(CDK_DRAG_PARENT) public cdk,
        private planningService: PlanningService,
        private projectService: ProjectService
    ) {
        super();
    }

    ngAfterViewInit() {
        // this.cdk._handles.length = 1;
        // this.cdk._handles._results = [this.handle];
        // this.cdk._handles.next();
    }

    ngOnInit() {
        this.subscriptions.add(
            this.searchAfasProjects$.pipe(debounceTime(200)).subscribe(search => {
                this.subscriptions.add(
                    this.projectService.searchProjects(search).subscribe(projectResponse => {
                        this.projects = projectResponse.data?.filter(p => !!p.parent_id);
                    })
                );
            })
        );
    }

    deletePlanning(planning: PlanningHasEntity) {
        if (planning.id) {
            this.planningService.deleteSingle(planning).then(() => {});
        } else {
            this.deletePlanningEmitter.emit(planning);
        }
    }

    changeEntity(planning: PlanningHasEntity, planningForm: PlanningForm, pheId: number) {
        this.addChooseEntity.emit({
            planningForm,
            type: planning.entitytype,
            pheId,
            disableFromCurrentPlanning: false,
        });
    }

    removeEntity(planningForm: PlanningForm, pheId: number) {
        const entity = planningForm.entities.find(e => e.planning.id === pheId);
        if (entity) {
            entity.planning.entity = null;
            entity.fg.controls.entity_id.setValue(null);
            entity.fg.controls.lowloader_entity_id.setValue(null);
            entity.fg.controls.truck_entity_id.setValue(null);
            entity.fg.controls.driver_user_id.setValue(null);
            entity.fg.controls.hiring_id.setValue(null);
            entity.fg.controls.name.setValue(null);
            entity.fg.markAsDirty();
        }
    }

    duplicatePlanning(planning: PlanningHasEntity, main: PlanningForm, formGroup: FormGroup, previous = false) {
        this.duplicatePlanningEmitter.emit({ planning, main, formGroup, previous });
    }

    duplicatePlanningExact(planning: PlanningHasEntity, main: PlanningForm, formGroup: FormGroup) {
        this.duplicateExactEmitter.emit({ planning, main, formGroup });
    }
}
